import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { INTEGRATION_TYPE_LABEL_KEYS } from '../../../../../../../../../constants';
import { Alert } from '../../../../../../../../../components/CiscoUi';

type SaasPanelNoDataAlertProps = {
  integrationType: IntegrationType;
};

export function SaasPanelNoDataAlert({
  integrationType,
}: SaasPanelNoDataAlertProps): ReactElement {
  const { t } = useTranslation();
  return (
    <Alert>
      {t(
        `sessions.panels.${INTEGRATION_TYPE_LABEL_KEYS[integrationType]}.noItemsAlert`,
      )}
    </Alert>
  );
}
